export default {"src":"/_next/static/media/virtual-desktop.a3008538.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};